module.exports = __webpack_public_path__ + "assets/media/system.bed12429.mp3";